import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { StyleService } from '../../services/style.service';

@Component({
  selector: 'app-multi-choice',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description radio-buttons">
    <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
    <div class="rating-dots-container">
      <div class="selected-color">
        <span *ngFor="let color of selectedRatingColors" class="rating-dot" [style.background-color]="color"></span>
      </div>
    </div>
    <mat-radio-group [ngClass]="{'pointer-events' : !field.style.editability}" [ngStyle]="_styleService.applyStyle(field)" class="example-radio-group" *ngFor="let item of field.data | keys;let i = index">
      <mat-radio-button class="example-radio-button" (change)="onChange(item)" [checked]="selected() === item.key" [value]="item.key">
        {{item.value}}
      </mat-radio-button>
    </mat-radio-group>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
`,
  styles: [`.check-boxes{float:left;width:100%}.check-boxes .max-image,.check-boxes .max-image-red{margin:0 0 15px!important}.rating-dots-container{width: 100%;text-align: right;float: left;}.rating-dot{height: 25px;width: 25px;background-color: green;border-radius: 50%;display: inline-block;margin-right: 3px;}.selected-color{float: right;width: 140px;text-align: left;}`]
})
export class RatingComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  showError = false;
  totalRatingColors = [];
  selectedRatingColors = [];
  constructor(
    private _validationService: ValidationService,
    private  _styleService : StyleService
  ) { }
  onChange(selectedItem) {
    let selectedOption = {};
    selectedOption[selectedItem.key] = selectedItem.value;
    this.field.value = selectedOption;
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    data[this.field.id] = this.field.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
    this.selectedRatingColors = [];
    for(let option of this.totalRatingColors) {
      if(selectedItem['key'] != Object.keys(option)[0]) {
        this.selectedRatingColors.push(option['color'])
      } else if(selectedItem['key'] == Object.keys(option)[0]){
        this.selectedRatingColors.push(option['color'])
        break;
      }
    }
  }

  selected() {
    if (this.field.value && this.field.value !== " ") {
      const items = Object.keys(this.field.value);
      return items[0];
    }
  }
  ngOnInit() {
    if(this.field.data) {
      this.totalRatingColors = this.field.data;
    }
    if (this.field.additionalInfo && this.field.value && this.field.value !== " ") {
      if (Object.keys(this.field.value).length > 0) {
        this.field.value.additionalInfo = {
          comments: this.field.value.additionalInfo.comments,
          images: this.field.value.additionalInfo.images
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/rating/rating.component.ts